// extracted by mini-css-extract-plugin
export default {"price":"o8-z","priceRow":"p8-z","onSale":"q8-z","msrpLabelPrice":"r8-z","msrpLabel":"s8-z","originalPrice":"t8-z","percentOff":"u8-z"};